import { render, staticRenderFns } from "./LoadingConsumi.vue?vue&type=template&id=d9629a4a"
import script from "./LoadingConsumi.vue?vue&type=script&lang=ts"
export * from "./LoadingConsumi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9629a4a')) {
      api.createRecord('d9629a4a', component.options)
    } else {
      api.reload('d9629a4a', component.options)
    }
    module.hot.accept("./LoadingConsumi.vue?vue&type=template&id=d9629a4a", function () {
      api.rerender('d9629a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-templates/LoadingConsumi.vue"
export default component.exports